import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchField } from '@react-spectrum/s2';
/** Width variants kept as static macro styles (the S2 `style()` macro cannot take
 *  runtime values). Fixed = the toolbar width used above data tables; fill = stretch
 *  to the container, for narrow sidebars and mobile. */ const FIXED_WIDTH = " ZX7Jjn171";
const FULL_WIDTH = " Za171";
export interface ToolbarSearchFieldProps {
    /** Accessible name — required since the control is unlabeled visually. */ 'aria-label': string;
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    /** Stretch to the container width (narrow sidebar / mobile) instead of the
   *  default fixed toolbar width. */ fill?: boolean;
}
/**
 * The single search control shared by every table toolbar and the domain listing
 * sidebar. Wraps the plain S2 `SearchField` so both surfaces render the identical
 * default Spectrum appearance (single border, inline icon, built-in clear button)
 * — no bespoke pill styling or double focus ring.
 */ export function ToolbarSearchField(props: ToolbarSearchFieldProps): React.ReactElement {
    const { t } = useTranslation();
    const { value, onChange, placeholder, fill = false } = props;
    return (<SearchField aria-label={props['aria-label']} placeholder={placeholder ?? t('components.toolbarSearchField.search')} value={value} onChange={onChange} styles={fill ? FULL_WIDTH : FIXED_WIDTH}/>);
}

import "macro-1e180a694384234cf3044ba552ef69b9ebf7c8499ffa2793916a507deba682da.css";
import "macro-2af0af3db39e823eecbe2179b7dbb30d92c11ddd6b0720dbf28502ac6c84b5fa.css";